const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  return lines;
};

const drawCover = (ctx, img, x, y, w, h) => {
  const scale = Math.max(w / img.width, h / img.height);
  const sw = w / scale;
  const sh = h / scale;
  ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h);
};

export async function downloadStoryImage(product) {
  await document.fonts.ready;
  await Promise.all([
    document.fonts.load('600 76px "Cormorant Garamond"'),
    document.fonts.load('italic 500 54px "Cormorant Garamond"'),
  ]).catch(() => {});

  const canvas = document.createElement("canvas");
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext("2d");

  const GOLD = "#A67C1E";
  const INK = "#211B10";
  const IVORY = "#FBF7EE";
  const CX = 540;

  ctx.fillStyle = IVORY;
  ctx.fillRect(0, 0, 1080, 1920);

  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 3;
  ctx.strokeRect(40, 40, 1000, 1840);
  ctx.strokeStyle = "rgba(166,124,30,0.35)";
  ctx.lineWidth = 1;
  ctx.strokeRect(58, 58, 964, 1804);

  try {
    const logo = await loadImage("/nalura-logo.jpg");
    ctx.globalCompositeOperation = "multiply";
    ctx.drawImage(logo, 450, 100, 180, 180);
    ctx.globalCompositeOperation = "source-over";
  } catch {}

  ctx.textAlign = "center";
  ctx.fillStyle = INK;
  ctx.font = '600 76px "Cormorant Garamond", serif';
  const brand = "NALURA";
  const bw = ctx.measureText(brand).width;
  ctx.fillText(brand, CX, 370);
  ctx.fillStyle = GOLD;
  ctx.fillText(".", CX + bw / 2 + 12, 370);

  ctx.fillStyle = GOLD;
  ctx.font = "500 26px monospace";
  ctx.fillText("G O O D   M I N D   G O O D   L I F E", CX, 425);

  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(CX - 60, 480);
  ctx.lineTo(CX + 60, 480);
  ctx.stroke();

  let quoteY = 700;
  if (product.image_url) {
    const backend = process.env.REACT_APP_BACKEND_URL;
    const sameOrigin = product.image_url.startsWith("/") || product.image_url.startsWith(window.location.origin);
    const src = sameOrigin ? product.image_url : `${backend}/api/image-proxy?url=${encodeURIComponent(product.image_url)}`;
    try {
      const img = await loadImage(src);
      drawCover(ctx, img, 160, 540, 760, 570);
      ctx.strokeStyle = INK;
      ctx.lineWidth = 2;
      ctx.strokeRect(160, 540, 760, 570);
      quoteY = 1230;
    } catch {}
  }

  const quote = product.promo_text || product.tagline || product.name;
  ctx.fillStyle = GOLD;
  ctx.font = '600 110px "Cormorant Garamond", serif';
  ctx.fillText("“", CX, quoteY - 10);

  ctx.fillStyle = INK;
  ctx.font = 'italic 500 54px "Cormorant Garamond", serif';
  const lines = wrapText(ctx, quote, 820).slice(0, 4);
  lines.forEach((l, i) => ctx.fillText(l, CX, quoteY + 70 + i * 72));

  ctx.fillStyle = GOLD;
  ctx.font = "600 28px monospace";
  ctx.fillText(product.name.toUpperCase(), CX, quoteY + 70 + lines.length * 72 + 60);

  ctx.fillStyle = INK;
  ctx.fillRect(160, 1660, 760, 140);
  ctx.fillStyle = "#EACB6B";
  ctx.font = "600 30px monospace";
  ctx.fillText("KLIK LINK DI BIO / STORY", CX, 1718);
  ctx.fillStyle = IVORY;
  ctx.font = "500 26px monospace";
  ctx.fillText(`${window.location.host}/p/${product.slug || product.product_id}`, CX, 1765);

  const blob = await new Promise((r) => canvas.toBlob(r, "image/png"));
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `nalura-story-${product.slug || product.product_id}.png`;
  a.click();
  URL.revokeObjectURL(url);
}
